import callAssistantIcon from '../../../Assets/icons/call_assistant_icon.svg';
import documentIcon from '../../../Assets/icons/document-icon.svg';
import findDocumentIcon from '../../../Assets/icons/find-document.svg';
import licenseIcon from '../../../Assets/icons/license-icon.svg';
import openEmailIcon from '../../../Assets/icons/open_email_icon.svg';
import paint1 from '../../../Assets/icons/paint1.svg';
import photoIcon from '../../../Assets/icons/photo-icon.svg';
import policeIcon from '../../../Assets/icons/police-icon.svg';
import truckIcon from '../../../Assets/icons/truck_icon.svg';
import autoContent from '../../../Assets/images/auto-content.svg';
import autoLanding from '../../../Assets/images/auto-landing.svg';
import computerLandingImage from '../../../Assets/images/computer-landing.png';
import './LandingContent.scss';

import { ArrowRightOutlined } from '@ant-design/icons';
import { Col, Collapse, CollapseProps, Row } from 'antd';
import { Link } from 'react-router-dom';
import { HOME_ROUTE } from '../../../Components/Router/constant';

export const LandingContentComponent = () => {
  const itemsStep1: CollapseProps['items'] = [
    {
      key: '1',
      label: '¿Qué hacer en caso de robo de vehículo?',
      children: (
        <div>
          El cliente o responsable del vehículo debe realizar de forma inmediata la denuncia ante la unidad policial más cercana <br />
          (PDI y/o Carabineros), y la vez, dar aviso vía Web o telefónica del suceso a GAMALEASING, a través de nuestro{' '}
          <strong className="organgeText">PORTAL DE SINIESTROS</strong> opción <strong className="organgeText">AVISO ROBO</strong> o al{' '}
          <strong className="organgeText">teléfono de Emergencias Gama 24/7 +56 2 2757 4450.</strong>
        </div>
      ),
    },
    {
      key: '2',
      label: '¿Cuál es el propósito del aviso inmediato del robo del vehículo?',
      children: (
        <div>
          Con el aviso de Robo se dará cumplimiento a las condiciones de cobertura de la póliza de seguros, el cual indica que el aviso de sustracción
          del Vehículo debe ser de manera inmediata y, además, Activar el protocolo de hallazgo y búsqueda de vehículos.
        </div>
      ),
    },
    {
      key: '3',
      label: '¿Qué necesitas para hacer el aviso del robo del vehículo?',
      children: (
        <div>
          Para formalizar la notificación se deberá ingresar con la Patente del Vehículo robado a la opción “Notificar robo total del vehículo” e
          nuestro portal y llenar un breve formulario sobre la descripción de los hechos.
        </div>
      ),
    },
  ];

  const itemsStep2: CollapseProps['items'] = [
    {
      key: '1',
      label: '¿Cuál es el plazo para realizar la declaración?',
      children: (
        <div>
          El cliente tiene un plazo de 48 horas para formalizar la declaración del siniestro a través del portal. Pasadas las 48 horas y de no
          formalizar la declaración es causal de rechazo de este.
        </div>
      ),
    },
    {
      key: '2',
      label: '¿Qué hacer en caso de un siniestro?',
      children: (
        <div>
          Recopilar antecedentes asociados al siniestro, como, por ejemplo: fotografías de daños. En caso de terceros involucrados, el cliente es
          responsable de informarlo en la declaración y en caso de tener información del tercero, a través del mismo portal podrá informar los
          antecedentes. Con los antecedentes a la mano deberá ingresar al portal y formalizar la declaración del siniestro.
        </div>
      ),
    },
    {
      key: '3',
      label: '¿Cómo declaro un siniestro?',
      children: (
        <div>
          El cliente debe ingresar al portal de seguros y siniestros, ingresar en la opción “DECLARAR SINIESTRO” con la patente del vehículo y
          completar la información requerida para la evaluación de su siniestro. Podrá hacerlo desde un computador o teléfono celular.
        </div>
      ),
    },
    {
      key: '4',
      label: '¿Cuál es la documentación que se debe adjuntar a la declaración de siniestro?',
      children: (
        <div>
          La documentaci&oacute;n depender&aacute; de la naturaleza del siniestro.
          <ul>
            <li>RUT/Pasaporte del conductor.</li>
            <li>Licencia de conducir del conductor.</li>
            <li>
              Croquis de la din&aacute;mica del siniestro. Aplica solo para los siniestros que involucran a terceros. Este croquis lo debe dibujar de
              forma manual el cliente explicando la din&aacute;mica del siniestro.
            </li>
            <li>Cuestionario de robo. Aplica solamente para las declaraciones que correspondan a robo de veh&iacute;culos.</li>
            <li>Denuncia o parte policial. Cuando exista.</li>
            <li>Resultados de alcoholemia. Cuando exista.</li>
          </ul>
        </div>
      ),
    },
  ];

  const itemsStep3: CollapseProps['items'] = [
    {
      key: '1',
      label: '¿Qué hacer en caso de tercero involucrados?',
      children: (
        <div>
          Independiente de la culpabilidad y de los daños al vehículo propio, siempre se debe declarar si hubo terceros involucrados con la mayor
          cantidad de información posible sobre el siniestro para una mayor cobertura. En caso de omitir en la declaración y no informar que hubo
          daños al tercero, el cliente debe hacerse responsable de las posibles responsabilidades civiles y de asistencia legal por lo que el costo
          recaerá en su totalidad sobre el cliente a modo de recobro. El canal para informar sobre el tercero involucrado es a través del mismo portal
          (DECLARACIÓN DE SINIESTRO).
        </div>
      ),
    },
  ];

  const itemsStep4: CollapseProps['items'] = [
    {
      key: '1',
      label: '¿En qué consiste la asistencia en ruta y cómo funciona?',
      children: (
        <div>
          La asistencia en ruta abarca:
          <ul>
            <li>Apertura de veh&iacute;culos cerrados.</li>
            <li>Remolque o transporte del veh&iacute;culo por accidente o aver&iacute;a.</li>
            <li>Cambio de neum&aacute;ticos.</li>
            <li>Carga y/o paso de corriente a bater&iacute;as.</li>
          </ul>
          En caso de requerir una grúa o asistencia, contáctese con el servicio 24/7 al fono +56 2 32785997.
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="landing-content-component sectionB">
        <div className="message1">¿Necesitas declarar un Siniestro?</div>
        <div>
          <Row justify="center">
            <Col span={20}>
              <Row>
                <Col md={24} lg={10} className="itemLeft">
                  <div>
                    Debes tener a mano <br />
                    la siguiente información
                    <div style={{ width: '100px' }}>
                      <img
                        src={computerLandingImage}
                        alt="computerLandingImage"
                        style={{
                          height: '250px',
                        }}
                      />
                    </div>
                  </div>
                </Col>
                <Col md={24} lg={4} className="itemCenter">
                  <img src={paint1} alt="paint1" height={480} />
                </Col>
                <Col md={24} lg={10} className="itemRigth">
                  <div className="documentGroupContent">
                    <div className="documentGroup">
                      <img src={documentIcon} alt="documentIcon" />
                      <span>Carnet de Identidad o Pasaporte</span>
                    </div>

                    <div className="documentGroup">
                      <img src={licenseIcon} alt="documentIcon" />
                      <span>Licencia de Conducir</span>
                    </div>

                    <div className="documentGroup">
                      <img src={photoIcon} alt="documentIcon" />
                      <span>Fotografías del daño en el vehículo</span>
                    </div>

                    <div className="documentGroup">
                      <img src={policeIcon} alt="documentIcon" />
                      <span>Parte o denuncia policial</span>
                    </div>

                    <div className="documentGroup">
                      <img src={findDocumentIcon} alt="documentIcon" />
                      <span>
                        Fotografías de daños e información del tercero <br />
                        (en caso de tercero involucrado)
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>

      <div className="section2">
        <Row justify="center">
          <Col span={20}>
            <Row>
              <div className="message2">¡A tener en cuenta!</div>
            </Row>
            <Row justify="center">
              <Col md={20} lg={12}>
                <ul>
                  <li>Para declarar el siniestro, dispones de 2 días hábiles desde la ocurrencia del mismo.</li>

                  <li>
                    Considerar que de no tener un documento, dispones de 48 horas para adjuntar la documentación requerida, luego de declarar el
                    siniestro.
                  </li>

                  <li>Es de manera obligatoria, declarar el siniestro en la web, ya que proporciona al cliente el respaldo de la declaración.</li>

                  <li>
                    Si necesitas declarar un siniestro por robo total del vehículo, recuerda que antes debes hacer la notificación del robo y es
                    importante formalizar la denuncia ante Carabineros.
                  </li>

                  <li>También puedes declarar desde tu teléfono celular escaneando el código QR.</li>
                </ul>
              </Col>
              <Col md={20} lg={12}>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <img src={autoContent} alt="autoContent" width="98%" />
                </div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '24px',
                  }}
                >
                  <Link className="qrPortalBtn" to={HOME_ROUTE}>
                    Ingresar al portal <ArrowRightOutlined />
                  </Link>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      <div className="landing-content-component section3">
        <div className="message1">Protocolo en caso de siniestro</div>

        <Row justify="center">
          <Col span={20}>
            <div className="form-steps">
              <div className="title">1. Aviso de robo</div>

              <Collapse items={itemsStep1} bordered={false} expandIconPosition="end" />
            </div>
          </Col>

          <Col span={20}>
            <div className="form-steps">
              <div className="title">2. Declaración de siniestro y envío de documentación</div>

              <Collapse items={itemsStep2} bordered={false} expandIconPosition="end" />
            </div>
          </Col>

          <Col span={20}>
            <div className="form-steps">
              <div className="title">3. Qué hacer en caso de terceros involucrados</div>

              <Collapse items={itemsStep3} bordered={false} expandIconPosition="end" />
            </div>
          </Col>

          <Col span={20}>
            <div className="form-steps">
              <div className="title">4. Información importante</div>

              <Collapse items={itemsStep4} bordered={false} expandIconPosition="end" />
            </div>
          </Col>

          <Col span={20} style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="step-recomendation">
              <div className="sub-recomendation1">
                <div className="message-recomendation">
                  Si te gustaría ver el protocolo de manera más detallada, puedes descargarlo en el siguiente botón.
                  <div
                    style={{
                      color: 'white',
                      marginTop: '35px',
                    }}
                  >
                    <a
                      style={{
                        borderRadius: '36px',
                        background: '#22B260',
                        // width: "260px",
                        padding: '8px 32px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '600',
                        lineHeight: '22px',
                      }}
                      href="/protocolo_de_siniestro.pdf"
                    >
                      Descargar protocolo <ArrowRightOutlined />
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <img src={autoLanding} alt="autoLanding" width="100%" />
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="landing-content-component section4">
        <div
          className="message1"
          style={{
            color: 'white',
            marginTop: 0,
            paddingTop: '100px',
          }}
        >
          Información de contacto
        </div>

        <div className="cards">
          <div className="card">
            <div>
              <img src={truckIcon} alt="truckIcon" />
            </div>

            <div>
              <strong style={{ color: 'white' }}>Grúas y Asistencia en Ruta 24/7</strong>
            </div>

            <div>
              <a className="phoneCta" href="tel:+56232785997">
                +56 2 3278 5997
              </a>
            </div>

            <ul>
              <li>Remolque o transporte del vehículo por accidente o avería.</li>
              <li>Cambio de neumático.</li>
              <li>Carga y/o paso de corriente a baterías.</li>
              <li>Apertura de vehículos cerrados.</li>
            </ul>
          </div>

          <div className="card">
            <div>
              <img src={callAssistantIcon} alt="callAssistantIcon" />
            </div>

            <div>
              <strong style={{ color: 'white' }}>
                Emergencias Gama 24/7 <br /> Aviso de Robo Vehículo
              </strong>
            </div>

            <div>
              <a className="phoneCta" href="tel:+56227574450">
                +56 2 2757 4450
              </a>
            </div>

            <ul>
              <li>Denuncia del robo de forma inmediata ante la unidad policial más cercana (PDI y/o Carabineros).</li>
            </ul>

            <div
              style={{
                color: 'white',
                marginTop: '50px',
              }}
            >
              <Link
                style={{
                  borderRadius: '36px',
                  background: '#22B260',
                  width: '260px',
                  padding: '8px 32px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: '600',
                  lineHeight: '22px',
                }}
                to={process.env.REACT_APP_THEFT_NOTIFICATION_URL ?? ''}
              >
                Aviso de robo aquí <ArrowRightOutlined />
              </Link>
            </div>
          </div>

          <div className="card">
            <div>
              <img src={openEmailIcon} alt="openEmailIcon" />
            </div>

            <div>
              <strong style={{ color: 'white' }}>Dudas Declaración de Siniestro</strong>
            </div>

            <div>
              <a className="phoneCta" href="tel:+56227574400">
                +56 2 2757 4400
              </a>
            </div>

            <ul>
              <li>Ante dudas o consultas: siniestros@gamamobility.cl</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
